module.exports = __webpack_public_path__ + "img/pickThree.a7ad81a3.webp";